import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useFirebaseAuth } from "../contexts/FirebaseAuthContext";

export function FirebaseProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useFirebaseAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ minHeight: "60vh", display: "grid", placeItems: "center", fontFamily: "'Poppins',sans-serif" }}>
        <p style={{ color: "#666" }}>Verifying admin session...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
